import { NgModule } from '@angular/core';
import { TranslateDirective } from './directives/translate.directive';
import { LanguagePipe } from './pipes/language.pipe';
import { TranslatePipe } from './pipes/translate.pipe';

@NgModule({
    imports: [
        TranslatePipe,
        LanguagePipe,
        TranslateDirective
    ],
    exports: [
        TranslatePipe,
        LanguagePipe,
        TranslateDirective
    ]
})
export class TranslationModule { }